<svg
  width="20"
  height="18"
  viewBox="0 0 20 18"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M8.5 18C9.32843 18 10 17.3284 10 16.5C10 15.6716 9.32843 15 8.5 15C7.67157 15 7 15.6716 7 16.5C7 17.3284 7.67157 18 8.5 18Z"
    fill="currentColor"
  />
  <path
    d="M15.5 18C16.3284 18 17 17.3284 17 16.5C17 15.6716 16.3284 15 15.5 15C14.6716 15 14 15.6716 14 16.5C14 17.3284 14.6716 18 15.5 18Z"
    fill="currentColor"
  />
  <path
    d="M11 10H13V7.01003H15.99V5.01003H13V2.03003H11V5.01003H8.01001V7.01003H11V10Z"
    fill="currentColor"
  />
  <path
    d="M8 14H16C16.2014 13.9994 16.398 13.938 16.564 13.8238C16.7299 13.7096 16.8575 13.5479 16.93 13.36L19.76 6H17.62L15.31 12H8.67L4.18 1.23C4.02776 0.865066 3.77077 0.553443 3.44149 0.334516C3.11221 0.115588 2.72542 -0.000819129 2.33 4.33887e-06H0V2H2.33L7.08 13.38C7.15502 13.5626 7.28242 13.719 7.44614 13.8293C7.60986 13.9396 7.80257 13.999 8 14Z"
    fill="currentColor"
  />
</svg>
